import React, { useState } from "react";
import { useOutletContext } from "react-router-dom";
import { OutletContextType } from "../../types/GlobalType";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  domainController,
  functionController,
  gradeController,
} from "../../_api/controllers/scolarite.controller.ts";
import { personalController } from "../../_api/controllers/personal.controller.ts";
import { userController } from "../../_api/controllers/user.controller.ts";
import { capitalizeFirstLetter } from "../../_services/utils";

const Personal: React.FC = () => {
  const { isDarkMode, setIsDarkMode } = useOutletContext<OutletContextType>();
  const [notification, setNotification] = useState<any>(null); // { message, type }
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState<any>(false); // { message, type }
  const showNotification = (message: string, type = "success") => {
    setNotification({ message, type });
    setTimeout(() => setNotification(null), 3000);
  };
  //filter personal
  const [searchQuery, setSearchQuery] = useState("");
  const [filtrerPersonalStatus, setfiltrerPersonalStatus] =
    useState<any>("Tous les status");
  const [isPersonalStatusDropdownOpen, setIsPersonalStatusDropdownOpen] =
    useState(false);
  const toggleEleveStatusDropdown = () => {
    setIsPersonalStatusDropdownOpen(!isPersonalStatusDropdownOpen);
  };
  const personalStatusDropdownRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      //status button
      if (
        personalStatusDropdownRef.current &&
        !personalStatusDropdownRef.current.contains(event.target as Node)
      ) {
        setIsPersonalStatusDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const [formEditData, setFormEditData] = useState<{
    id: any;
    nom: string;
    postnom: string;
    prenom: string;
    genre: string;
    ville: string;
    commune: string;
    quartier: string;
    avenue: string;
    telephone: string;
    uid: string;
    fonction_id: any;
    grade_id: any;
    date_naissance: string;
    lieu_naissance: string;
    domaine_id: any;
    email: string;
  }>({
    id: "",
    nom: "",
    postnom: "",
    prenom: "",
    genre: "",
    ville: "",
    commune: "",
    quartier: "",
    avenue: "",
    telephone: "",
    uid: "12345688",
    fonction_id: "",
    grade_id: "",
    date_naissance: "",
    lieu_naissance: "",
    domaine_id: "",
    email: "",
  });
  const [formNewData, setFormNewData] = useState<{
    nom: string;
    postnom: string;
    prenom: string;
    genre: string;
    ville: string;
    commune: string;
    quartier: string;
    avenue: string;
    telephone: string;
    uid: string;
    fonction_id: any;
    grade_id: any;
    date_naissance: string;
    lieu_naissance: string;
    domaine_id: any;
    email: string;
  }>({
    nom: "",
    postnom: "",
    prenom: "",
    genre: "",
    ville: "",
    commune: "",
    quartier: "",
    avenue: "",
    telephone: "",
    uid: "12345688",
    fonction_id: "",
    grade_id: "",
    date_naissance: "",
    lieu_naissance: "",
    domaine_id: "",
    email: "",
  });

  const handleChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    showEditModal
      ? setFormEditData((prev) => ({ ...prev, [name]: value }))
      : setFormNewData((prev) => ({ ...prev, [name]: value }));
  };

  //UseReducer for Desactivate, Activate
  //handleling delete & activate & desactivate items
  interface ActionState {
    actionSection: string;
    actionType: string;
    actionText: string;
    currentId: any;
  }

  interface Action {
    type: "DELETE" | "DESACTIVATE" | "CANCEL" | "ACTIVATE";
    payload: { actionText: string; actionSection: string; currentId: any };
  }
  const ACTION_TYPES = {
    DELETE: "DELETE",
    DESACTIVATE: "DESACTIVATE",
    ACTIVATE: "ACTIVATE",
    CANCEL: "CANCEL",
  };

  const INITIAL_STATE: ActionState = {
    actionSection: "",
    actionType: "",
    actionText: "",
    currentId: null,
  };

  const actionReducer = (state: ActionState, action: Action): ActionState => {
    switch (action.type) {
      case ACTION_TYPES.DELETE:
        return {
          ...state,
          actionType: "delete",
          actionSection: action.payload.actionSection,
          actionText: action.payload.actionText,
          currentId: action.payload.currentId,
        };

      case ACTION_TYPES.ACTIVATE:
        return {
          ...state,
          actionType: "activate",
          actionSection: action.payload.actionSection,
          actionText: action.payload.actionText,
          currentId: action.payload.currentId,
        };
      case ACTION_TYPES.DESACTIVATE:
        return {
          ...state,
          actionType: "desactivate",
          actionSection: action.payload.actionSection,
          actionText: action.payload.actionText,
          currentId: action.payload.currentId,
        };
      case ACTION_TYPES.CANCEL:
        return {
          actionSection: "",
          actionType: "",
          actionText: "",
          currentId: null,
        };

      default:
        return state;
    }
  };

  const [state_actions, dispatch] = React.useReducer(
    actionReducer,
    INITIAL_STATE
  );

  const queryClient = useQueryClient();

  //fetch all users
  const { data: personalData } = useQuery({
    queryKey: ["personals"],
    queryFn: personalController.getAll,
  });

  //fetch all personals
  const { data: usersData } = useQuery({
    queryKey: ["users"],
    queryFn: userController.getAll,
  });

  //fetch all domains
  const { data: domainData } = useQuery({
    queryKey: ["domains"],
    queryFn: domainController.getAll,
  });

  //fetch all functions
  const { data: functionData } = useQuery({
    queryKey: ["functions"],
    queryFn: functionController.getAll,
  });
  //fetch all grade
  const { data: gradeData } = useQuery({
    queryKey: ["grades"],
    queryFn: gradeController.getAll,
  });

  const personalDataArr = personalData?.data || [];
  const usersDataArr = usersData?.data || [];
  const domainDataArr = domainData?.data || [];
  const functionDataArr = functionData?.data || [];
  const gradeDataArr = gradeData?.data || [];

  const updatePersonnalDataArr = personalDataArr.map((personal) => {
    let fonctionDesignation: string = "",
      gradeDesignation: string = "",
      domaineDesignation: string = "",
      email: string = "",
      userAccount: boolean = false;

    for (let item of domainDataArr) {
      if (personal.domaine_id === item.id) {
        domaineDesignation = item.designation;
      }
    }
    for (let item of functionDataArr) {
      if (personal.fonction_id === item.id) {
        fonctionDesignation = item.designation;
      }
    }
    for (let item of gradeDataArr) {
      if (personal.grade_id === item.id) {
        gradeDesignation = item.designation;
      }
    }
    for (let item of usersDataArr) {
      if (!!item.status && personal.personnel_id === item.personnel_id) {
        userAccount = true;
        email = item.email;
      }
    }
    return {
      ...personal,
      personalAccount: userAccount,
      fonctionDesignation,
      gradeDesignation,
      domaineDesignation,
    };
  });

  //statistic number
  let studentStats = {
    total: updatePersonnalDataArr.length,
    active: updatePersonnalDataArr.filter((item) => item.status).length,
    inactive: updatePersonnalDataArr.filter((item) => !item.status).length,
    systemAccount: updatePersonnalDataArr.filter((item) => item.personalAccount)
      .length,
  };

  const filteredPersonals = updatePersonnalDataArr.filter((personal) => {
    const matchesQuery =
      personal.nom.toLowerCase().includes(searchQuery.toLowerCase()) ||
      personal.postnom.toLowerCase().includes(searchQuery.toLowerCase()) ||
      personal.prenom.toLowerCase().includes(searchQuery.toLowerCase());

    const matchesStudentStatus =
      filtrerPersonalStatus === "Tous les status" ||
      filtrerPersonalStatus == personal.status;

    return matchesQuery && matchesStudentStatus;
  });

  const mutationDesactivatePersonal = useMutation({
    mutationFn: () => personalController.desactivate(state_actions.currentId),

    onSuccess: (data) => {
      console.log(data);
      showNotification("Désactivation effectuée avec succès", "success");
      dispatch({
        type: "CANCEL",
        payload: { actionText: "", currentId: null, actionSection: "" },
      });
      // setCurrentId(null);
      queryClient.invalidateQueries({ queryKey: ["personals"] });
    },

    onError: (err) => {
      console.log(err);
      showNotification("Une erreur est survenue, réessayer....", "error");
    },
  });

  const mutationActivatePersonal = useMutation({
    mutationFn: () => personalController.activate(state_actions.currentId),

    onSuccess: (data) => {
      showNotification("Activation effectuée avec succès", "success");
      dispatch({
        type: "CANCEL",
        payload: { actionText: "", currentId: null, actionSection: "" },
      });
      // setCurrentId(null);
      queryClient.invalidateQueries({ queryKey: ["personals"] });
    },

    onError: (err: any) => {
      showNotification("Une erreur est survenue, réessayer....", "error");
    },
  });

  const mutationUpdatePersonal = useMutation({
    mutationFn: () =>
      personalController.update(formEditData.id, {
        nom: formEditData.nom,
        postnom: formEditData.postnom,
        prenom: formEditData.prenom,
        sexe: formEditData.genre,
        ville: formEditData.ville,
        commune: formEditData.commune,
        quartier: formEditData.quartier,
        avenue: formEditData.avenue,
        telephone: formEditData.telephone,
        uid: "12345688",
        fonction_id: formEditData.fonction_id,
        grade_id: formEditData.grade_id,
        date_naissance: formEditData.date_naissance,
        lieu_naissance: formEditData.lieu_naissance,
        domaine_id: formEditData.domaine_id,
        email: formEditData.email,
      }),

    onSuccess: () => {
      setShowEditModal(false);
      showNotification("Modification effectuée avec succès", "success");
      setFormEditData({
        id: "",
        nom: "",
        postnom: "",
        prenom: "",
        genre: "",
        date_naissance: "",
        lieu_naissance: "",
        ville: "",
        commune: "",
        quartier: "",
        avenue: "",
        telephone: "",
        uid: "12345678",
        fonction_id: "",
        grade_id: "",
        domaine_id: "",
        email: "",
      });
      queryClient.invalidateQueries({ queryKey: ["personals"] });
    },

    onError: () => {
      showNotification("Une erreur est survenue, réessayer....", "error");
    },
  });
  const mutationCreatePersonal = useMutation({
    mutationFn: () =>
      personalController.create({
        nom: formNewData.nom,
        postnom: formNewData.postnom,
        prenom: formNewData.prenom,
        sexe: formNewData.genre,
        ville: formNewData.ville,
        commune: formNewData.commune,
        quartier: formNewData.quartier,
        avenue: formNewData.avenue,
        telephone: formNewData.telephone,
        uid: "12345688",
        fonction_id: formNewData.fonction_id,
        grade_id: formNewData.grade_id,
        date_naissance: formNewData.date_naissance,
        lieu_naissance: formNewData.lieu_naissance,
        domaine_id: formNewData.domaine_id,
        email: formNewData.email,
      }),

    onSuccess: () => {
      setShowAddModal(false);
      showNotification("Modification effectuée avec succès", "success");
      setFormNewData({
        nom: "",
        postnom: "",
        prenom: "",
        genre: "",
        date_naissance: "",
        lieu_naissance: "",
        ville: "",
        commune: "",
        quartier: "",
        avenue: "",
        telephone: "",
        uid: "12345678",
        fonction_id: "",
        grade_id: "",
        domaine_id: "",
        email: "",
      });
      queryClient.invalidateQueries({ queryKey: ["personals"] });
    },

    onError: () => {
      showNotification("Une erreur est survenue, réessayer....", "error");
    },
  });

  const handleActivate = () => {
    if (
      state_actions.actionType === "activate" &&
      state_actions.actionSection === "personal"
    ) {
      mutationActivatePersonal.mutate();
    }
  };

  const handleDesactivate = () => {
    if (
      state_actions.actionType === "desactivate" &&
      state_actions.actionSection === "personal"
    ) {
      mutationDesactivatePersonal.mutate();
    }
  };

  const handleUpdatePersonal = () => {
    const {
      nom,
      postnom,
      prenom,
      genre,
      lieu_naissance,
      date_naissance,
      ville,
      commune,
      quartier,
      avenue,
      email,
      fonction_id,
      domaine_id,
      grade_id,
    } = formEditData;
    if (
      !nom ||
      !postnom ||
      !prenom ||
      !genre ||
      !lieu_naissance ||
      !date_naissance ||
      !ville ||
      !commune ||
      !quartier ||
      !avenue ||
      !email ||
      !fonction_id ||
      !grade_id ||
      !domaine_id
    ) {
      // console.log(formEditData);
      return showNotification(
        "Veuillez renseigner tous les champs obligatoires",
        "erreur"
      );
    } else {
      // console.log(formEditData);
      mutationUpdatePersonal.mutate();
    }

    // console.log("nothing");
  };
  const handleCreatePersonal = () => {
    const {
      nom,
      postnom,
      prenom,
      genre,
      lieu_naissance,
      date_naissance,
      ville,
      commune,
      quartier,
      avenue,
      email,
      fonction_id,
      domaine_id,
      grade_id,
    } = formNewData;
    if (
      !nom ||
      !postnom ||
      !prenom ||
      !genre ||
      !lieu_naissance ||
      !date_naissance ||
      !ville ||
      !commune ||
      !quartier ||
      !avenue ||
      !email ||
      !fonction_id ||
      !grade_id ||
      !domaine_id
    ) {
      console.log(formNewData);
      return showNotification(
        "Veuillez renseigner tous les champs obligatoires",
        "erreur"
      );
    } else {
      // console.log(formEditData);
      mutationCreatePersonal.mutate();
    }

    // console.log("nothing");
  };
  return (
    <div className="space-y-6">
      <div
        className={`rounded-lg overflow-hidden border ${
          isDarkMode ? "border-gray-700" : "border-gray-300"
        }`}
      >
        <div className={`p-5 ${isDarkMode ? "bg-[#0D1117]" : "bg-white"}`}>
          {/* Stats Cards */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
            <div
              className={`p-4 rounded-lg ${
                isDarkMode ? "bg-[#161B22]" : "bg-gray-50"
              } border ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <p
                    className={`text-sm ${
                      isDarkMode ? "text-gray-400" : "text-gray-600"
                    }`}
                  >
                    Total Personnel
                  </p>
                  <h3 className="text-2xl font-bold">{studentStats.total}</h3>
                </div>
                <div
                  className={`p-3 rounded-full ${
                    isDarkMode ? "bg-blue-900" : "bg-blue-100"
                  }`}
                >
                  <i
                    className={`fas fa-users ${
                      isDarkMode ? "text-blue-400" : "text-blue-600"
                    }`}
                  ></i>
                </div>
              </div>
            </div>
            <div
              className={`p-4 rounded-lg ${
                isDarkMode ? "bg-[#161B22]" : "bg-gray-50"
              } border ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <p
                    className={`text-sm ${
                      isDarkMode ? "text-gray-400" : "text-gray-600"
                    }`}
                  >
                    Actifs
                  </p>
                  <h3 className="text-2xl font-bold">{studentStats.active}</h3>
                </div>
                <div
                  className={`p-3 rounded-full ${
                    isDarkMode ? "bg-green-900" : "bg-green-100"
                  }`}
                >
                  <i
                    className={`fas fa-user-check ${
                      isDarkMode ? "text-green-400" : "text-green-600"
                    }`}
                  ></i>
                </div>
              </div>
            </div>
            <div
              className={`p-4 rounded-lg ${
                isDarkMode ? "bg-[#161B22]" : "bg-gray-50"
              } border ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <p
                    className={`text-sm ${
                      isDarkMode ? "text-gray-400" : "text-gray-600"
                    }`}
                  >
                    Inactifs
                  </p>
                  <h3 className="text-2xl font-bold">
                    {studentStats.inactive}
                  </h3>
                </div>
                <div
                  className={`p-3 rounded-full ${
                    isDarkMode ? "bg-gray-800" : "bg-gray-200"
                  }`}
                >
                  <i
                    className={`fas fa-archive ${
                      isDarkMode ? "text-gray-400" : "text-gray-600"
                    }`}
                  ></i>
                </div>
              </div>
            </div>
            <div
              className={`p-4 rounded-lg ${
                isDarkMode ? "bg-[#161B22]" : "bg-gray-50"
              } border ${isDarkMode ? "border-gray-700" : "border-gray-200"}`}
            >
              <div className="flex items-center justify-between">
                <div>
                  <p
                    className={`text-sm ${
                      isDarkMode ? "text-gray-400" : "text-gray-600"
                    }`}
                  >
                    Avec compte
                  </p>
                  <h3 className="text-2xl font-bold">
                    {studentStats.systemAccount}
                  </h3>
                </div>
                <div
                  className={`p-3 rounded-full ${
                    isDarkMode ? "bg-purple-900" : "bg-purple-100"
                  }`}
                >
                  <i
                    className={`fas fa-user-shield ${
                      isDarkMode ? "text-purple-400" : "text-purple-600"
                    }`}
                  ></i>
                </div>
              </div>
            </div>
          </div>
          {/* Search and Filters */}
          <div className="flex flex-wrap gap-4 mb-6">
            <div className="flex-grow relative">
              <div
                className={`absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-gray-500`}
              >
                <i className="fas fa-search"></i>
              </div>
              <input
                type="text"
                placeholder="Rechercher un membre du personnel..."
                className={`w-full pl-10 pr-4 py-2 rounded-md text-sm ${
                  isDarkMode
                    ? "bg-[#161B22] border-gray-700"
                    : "bg-white border-gray-300"
                } border focus:outline-none focus:ring-2 focus:ring-blue-500`}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
            <div className="relative">
              <button
                onClick={toggleEleveStatusDropdown}
                className={`flex items-center px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-[#161B22] hover:bg-gray-700"
                    : "bg-white hover:bg-gray-100"
                } border ${
                  isDarkMode ? "border-gray-700" : "border-gray-300"
                } !rounded-button whitespace-nowrap`}
              >
                <span>
                  {filtrerPersonalStatus == 1
                    ? "Active"
                    : filtrerPersonalStatus == 0
                    ? "Désactivé"
                    : "Tous les status"}
                </span>
                <i className="fas fa-chevron-down ml-2"></i>
              </button>
              {isPersonalStatusDropdownOpen && (
                <div
                  className={`absolute top-full left-0 mt-1 w-40 rounded-md shadow-lg ${
                    isDarkMode ? "bg-[#161B22]" : "bg-white"
                  } border ${
                    isDarkMode ? "border-gray-700" : "border-gray-300"
                  } z-50`}
                  ref={personalStatusDropdownRef}
                >
                  <div className="py-1">
                    {[
                      {
                        id: 0,
                        designation: "Tous les status",
                        status: "Tous les status",
                      },
                      { id: 1, designation: "Active", status: 1 },
                      { id: 2, designation: "Désactivé", status: 0 },
                    ].map((status) => (
                      <button
                        key={status.id}
                        onClick={() => {
                          setfiltrerPersonalStatus(status.status);
                          setIsPersonalStatusDropdownOpen(false);
                        }}
                        className={`block w-full text-left px-4 py-2 text-sm ${
                          isDarkMode
                            ? "hover:bg-gray-700 text-gray-200"
                            : "hover:bg-gray-100 text-gray-700"
                        } !rounded-button whitespace-nowrap`}
                      >
                        {status.designation}
                      </button>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <button
              onClick={() => setShowAddModal(true)}
              className={`px-4 py-2 rounded-md ${
                isDarkMode
                  ? "bg-green-600 hover:bg-green-700"
                  : "bg-green-500 hover:bg-green-600"
              } text-white !rounded-button whitespace-nowrap`}
            >
              <i className="fas fa-plus mr-2"></i>Ajouter un membre
            </button>
          </div>
          {/* Personnel Table */}
          <div
            className={`rounded-lg overflow-hidden border ${
              isDarkMode ? "border-gray-700" : "border-gray-300"
            }`}
          >
            <table className="min-w-full divide-y divide-gray-700">
              <thead
                className={`${isDarkMode ? "bg-[#161B22]" : "bg-gray-50"}`}
              >
                <tr>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                  >
                    Nom & Prénom
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                  >
                    Fonction
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                  >
                    Grade
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                  >
                    Compte système
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider"
                  >
                    Statut
                  </th>
                  <th
                    scope="col"
                    className="px-6 py-3 text-center text-xs font-medium uppercase tracking-wider"
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody
                className={`${
                  isDarkMode ? "bg-[#0D1117]" : "bg-white"
                } divide-y ${
                  isDarkMode ? "divide-gray-700" : "divide-gray-200"
                }`}
              >
                {filteredPersonals.map((item, index) => {
                  return (
                    <tr>
                      <td key={item.id} className="px-6 py-4 whitespace-nowrap">
                        <div className="flex items-center">
                          <div className="flex-shrink-0 h-10 w-10">
                            <div
                              className={`h-10 w-10 rounded-full flex items-center justify-center ${
                                isDarkMode ? "bg-gray-700" : "bg-gray-200"
                              }`}
                            >
                              <i className="fas fa-user"></i>
                            </div>
                          </div>
                          <div className="ml-4">
                            <span
                              className={`px-0 inline-flex text-xs leading-5 font-semibold rounded-full ${
                                isDarkMode ? "text-gray-200" : "text-gray-700"
                              }`}
                            >
                              {capitalizeFirstLetter(item.nom)}{" "}
                              {capitalizeFirstLetter(item.postnom)}{" "}
                              {capitalizeFirstLetter(item.prenom)}
                            </span>{" "}
                            <div
                              className={`text-sm ${
                                isDarkMode ? "text-gray-400" : "text-gray-500"
                              }`}
                            >
                              ID: PRF-00{index + 1}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {item.fonctionDesignation}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        {item.gradeDesignation}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span
                          className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                            item.personalAccount
                              ? "bg-green-100 text-green-800"
                              : "bg-red-100 text-red-800"
                          } `}
                        >
                          {item.personalAccount ? "Actif" : "Inactif"}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap">
                        <span
                          className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                            item.status
                              ? "bg-blue-100 text-blue-800"
                              : "bg-red-100 text-red-800"
                          } `}
                        >
                          {item.status ? "Active" : "Inactive"}
                        </span>
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-center">
                        <div className="flex justify-center space-x-3">
                          {/* <button className="text-blue-500 hover:text-blue-700 cursor-pointer !rounded-button whitespace-nowrap">
                            <i className="fas fa-eye"></i>
                          </button> */}
                          <button
                            onClick={() => {
                              setFormEditData({
                                id: item.personnel_id,
                                nom: item.nom,
                                postnom: item.postnom,
                                prenom: item.prenom,
                                genre: item.sexe,
                                ville: item.ville,
                                commune: item.commune,
                                quartier: item.quartier,
                                avenue: item.avenue,
                                telephone: item.telephone,
                                uid: "12345688",
                                fonction_id: item.fonction_id,
                                grade_id: item.grade_id,
                                date_naissance: item.date_naissance,
                                lieu_naissance: item.lieu_naissance,
                                domaine_id: item.domaine_id,
                                email: item.email,
                              });
                              setShowEditModal(true);
                            }}
                            className="text-green-500 hover:text-green-700 cursor-pointer !rounded-button whitespace-nowrap"
                          >
                            <i className="fas fa-edit"></i>
                          </button>
                          <button
                            onClick={() => {
                              item.status
                                ? dispatch({
                                    type: "DESACTIVATE",
                                    payload: {
                                      actionText:
                                        "Êtes-vous sûr de vouloir désactiver ce personnel?",
                                      currentId: item.personnel_id,
                                      actionSection: "personal",
                                    },
                                  })
                                : dispatch({
                                    type: "ACTIVATE",
                                    payload: {
                                      actionText:
                                        "Êtes-vous sûr de vouloir Activer ce personnel?",
                                      currentId: item.personnel_id,
                                      actionSection: "personal",
                                    },
                                  });
                            }}
                            className={`${
                              item.status
                                ? "text-green-500 hover:text-green-700"
                                : "text-gray-500 hover:text-green-700"
                            } cursor-pointer !rounded-button whitespace-nowrap`}
                          >
                            <i className="fa-solid fa-circle-check"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {/* Pagination */}
          <div className="mt-4 flex items-center justify-between">
            <div
              className={`text-sm ${
                isDarkMode ? "text-gray-400" : "text-gray-500"
              }`}
            >
              Affichage de 1 à 10 sur 45 membres
            </div>
          </div>
        </div>
      </div>

      {/* Activate dialog */}
      {state_actions.actionType === "activate" && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div
            className={`${
              isDarkMode ? "bg-[#1c2128]" : "bg-white"
            } rounded-lg shadow-xl w-full max-w-md mx-4 p-6`}
          >
            <div className="text-xl font-medium mb-4">
              Confirmer l'activation
            </div>
            <p
              className={`${
                isDarkMode ? "text-gray-300" : "text-gray-600"
              } mb-6`}
            >
              {state_actions.actionText}
            </p>
            <div className="flex justify-end space-x-3">
              <button
                disabled={mutationActivatePersonal.isPending}
                onClick={() =>
                  dispatch({
                    type: "CANCEL",
                    payload: {
                      actionText: "",
                      currentId: "",
                      actionSection: "",
                    },
                  })
                }
                className={`px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-gray-700 hover:bg-gray-600"
                    : "bg-gray-200 hover:bg-gray-300"
                } !rounded-button whitespace-nowrap ${
                  mutationActivatePersonal.isPending ? "cursor-not-allowed" : ""
                }`}
              >
                Annuler
              </button>
              <button
                disabled={mutationActivatePersonal.isPending}
                onClick={handleActivate}
                className={`px-4 py-2 rounded-md bg-blue-500 hover:bg-blue-600 text-white !rounded-button whitespace-nowrap ${
                  mutationActivatePersonal.isPending ? "cursor-not-allowed" : ""
                }`}
              >
                {mutationActivatePersonal.isPending ? (
                  <span className="flex items-center justify-center">
                    <i className="fas fa-spinner fa-spin mr-2"></i>
                    Activation en cours...
                  </span>
                ) : (
                  "Confirmer l'activation"
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Desactivate dialog */}
      {state_actions.actionType === "desactivate" && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div
            className={`${
              isDarkMode ? "bg-[#1c2128]" : "bg-white"
            } rounded-lg shadow-xl w-full max-w-md mx-4 p-6`}
          >
            <div className="text-xl font-medium mb-4">
              Confirmer la désactivation
            </div>
            <p
              className={`${
                isDarkMode ? "text-gray-300" : "text-gray-600"
              } mb-6`}
            >
              {state_actions.actionText}
            </p>
            <div className="flex justify-end space-x-3">
              <button
                disabled={mutationDesactivatePersonal.isPending}
                onClick={() =>
                  dispatch({
                    type: "CANCEL",
                    payload: {
                      actionText: "",
                      currentId: "",
                      actionSection: "",
                    },
                  })
                }
                className={`px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-gray-700 hover:bg-gray-600"
                    : "bg-gray-200 hover:bg-gray-300"
                } !rounded-button whitespace-nowrap ${
                  mutationDesactivatePersonal.isPending
                    ? "cursor-not-allowed"
                    : ""
                }`}
              >
                Annuler
              </button>
              <button
                disabled={mutationDesactivatePersonal.isPending}
                onClick={handleDesactivate}
                className={`px-4 py-2 rounded-md bg-red-500 hover:bg-red-600 text-white !rounded-button whitespace-nowrap ${
                  mutationDesactivatePersonal.isPending
                    ? "cursor-not-allowed"
                    : ""
                }`}
              >
                {mutationDesactivatePersonal.isPending ? (
                  <span className="flex items-center justify-center">
                    <i className="fas fa-spinner fa-spin mr-2"></i>
                    Désactivation en cours...
                  </span>
                ) : (
                  "Confirmer la désactivation"
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Edit && Add personal Modal */}
      {(showEditModal || showAddModal) && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div
            className={`${
              isDarkMode ? "bg-[#1c2128]" : "bg-white"
            } rounded-lg shadow-xl w-full max-w-[70%] p-6 mx-4`}
          >
            {/* Header */}
            <div
              className={`pr-6 pt-2 pb-4 border-b ${
                isDarkMode ? "border-gray-700" : "border-gray-200"
              } flex justify-between items-center`}
            >
              <h3 className="text-xl font-medium">
                {showEditModal
                  ? "Modifier Personnel"
                  : "Ajouter nouveau personnel"}
              </h3>
              <button
                onClick={() => {
                  showEditModal
                    ? setShowEditModal(false)
                    : setShowAddModal(false);
                }}
                className="text-gray-500 hover:text-gray-700"
              >
                <i className="fas fa-times"></i>
              </button>
            </div>

            {/* Form */}
            <>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-4 mt-4">
                <div>
                  <label
                    htmlFor={`nom`}
                    className={`block text-sm font-medium ${
                      isDarkMode ? "text-gray-400" : "text-600"
                    } `}
                  >
                    Nom <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id={`nom`}
                    name="nom"
                    required
                    value={showEditModal ? formEditData.nom : formNewData.nom}
                    onChange={handleChange}
                    className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                      isDarkMode
                        ? "bg-[#0D1117] border-gray-700"
                        : "bg-gray-50 border-gray-200"
                    }`}
                  />
                </div>
                <div>
                  <label
                    htmlFor={`postnom`}
                    className={`block text-sm font-medium ${
                      isDarkMode ? "text-gray-400" : "text-600"
                    } `}
                  >
                    Post-Nom <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id={`postnom`}
                    name="postnom"
                    required
                    value={
                      showEditModal ? formEditData.postnom : formNewData.postnom
                    }
                    onChange={handleChange}
                    className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                      isDarkMode
                        ? "bg-[#0D1117] border-gray-700"
                        : "bg-gray-50 border-gray-200"
                    }`}
                  />
                </div>
                <div>
                  <label
                    htmlFor={`prenom`}
                    className={`block text-sm font-medium ${
                      isDarkMode ? "text-gray-400" : "text-600"
                    } `}
                  >
                    Prénom <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id={`prenom`}
                    name="prenom"
                    required
                    value={
                      showEditModal ? formEditData.prenom : formNewData.prenom
                    }
                    onChange={handleChange}
                    className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                      isDarkMode
                        ? "bg-[#0D1117] border-gray-700"
                        : "bg-gray-50 border-gray-200"
                    }`}
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-4">
                <div>
                  <label
                    htmlFor={`genre`}
                    className={`block text-sm font-medium ${
                      isDarkMode ? "text-gray-400" : "text-600"
                    } `}
                  >
                    Genre <span className="text-red-500">*</span>
                  </label>
                  <select
                    id={`genre`}
                    name="genre"
                    required
                    value={
                      showEditModal ? formEditData.genre : formNewData.genre
                    }
                    onChange={handleChange}
                    className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                      isDarkMode
                        ? "bg-[#0D1117] border-gray-700"
                        : "bg-gray-50 border-gray-200"
                    }`}
                  >
                    <option value="">Sélectionner</option>
                    <option value="M">MASCULIN</option>
                    <option value="F">FEMININ</option>
                  </select>
                </div>

                <div>
                  <label
                    htmlFor={`lieuxNaissance`}
                    className={`block text-sm font-medium ${
                      isDarkMode ? "text-gray-400" : "text-600"
                    } `}
                  >
                    Lieux de naissance <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    id={`lieuxNaissance`}
                    name="lieuxNaissance"
                    required
                    value={
                      showEditModal
                        ? formEditData.lieu_naissance
                        : formNewData.lieu_naissance
                    }
                    onChange={(e) =>
                      showEditModal
                        ? setFormEditData((prev) => ({
                            ...prev,
                            lieu_naissance: e.target.value,
                          }))
                        : setFormNewData((prev) => ({
                            ...prev,
                            lieu_naissance: e.target.value,
                          }))
                    }
                    className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                      isDarkMode
                        ? "bg-[#0D1117] border-gray-700"
                        : "bg-gray-50 border-gray-200"
                    }`}
                  />
                </div>
                <div>
                  <label
                    htmlFor={`date_naissance`}
                    className={`block text-sm font-medium ${
                      isDarkMode ? "text-gray-400" : "text-600"
                    } `}
                  >
                    Date de Naissance <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="date"
                    id={`date_naissance`}
                    name="date_naissance"
                    required
                    value={
                      showEditModal
                        ? formEditData.date_naissance
                        : formNewData.date_naissance
                    }
                    onChange={handleChange}
                    className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                      isDarkMode
                        ? "bg-[#0D1117] border-gray-700"
                        : "bg-gray-50 border-gray-200"
                    }`}
                  />
                </div>
              </div>

              <div className="space-y-6">
                <div>
                  <h3
                    className={`text-lg font-medium  ${
                      isDarkMode ? "text-gray-400" : "text-gray-600"
                    }`}
                  >
                    Adresse principale
                  </h3>
                  <div className="mt-4 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                    <div className="sm:col-span-4">
                      <label
                        htmlFor="avenue"
                        className={`block text-sm font-medium ${
                          isDarkMode ? "text-gray-400" : "text-600"
                        } `}
                      >
                        Avenue <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="avenue"
                        id="avenue"
                        required
                        value={
                          showEditModal
                            ? formEditData.avenue
                            : formNewData.avenue
                        }
                        onChange={handleChange}
                        className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                          isDarkMode
                            ? "bg-[#0D1117] border-gray-700"
                            : "bg-gray-50 border-gray-200"
                        }`}
                      />
                    </div>
                    <div className="sm:col-span-2">
                      <label
                        htmlFor="quartier"
                        className={`block text-sm font-medium ${
                          isDarkMode ? "text-gray-400" : "text-600"
                        } `}
                      >
                        Quartier <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="quartier"
                        id="quartier"
                        required
                        value={
                          showEditModal
                            ? formEditData.quartier
                            : formNewData.quartier
                        }
                        onChange={handleChange}
                        className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                          isDarkMode
                            ? "bg-[#0D1117] border-gray-700"
                            : "bg-gray-50 border-gray-200"
                        }`}
                      />
                    </div>
                  </div>
                  <div className="mt-4 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                    <div className="sm:col-span-2">
                      <label
                        htmlFor="commune"
                        className={`block text-sm font-medium ${
                          isDarkMode ? "text-gray-400" : "text-600"
                        } `}
                      >
                        commune <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="commune"
                        id="commune"
                        required
                        value={
                          showEditModal
                            ? formEditData.commune
                            : formNewData.commune
                        }
                        onChange={handleChange}
                        className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                          isDarkMode
                            ? "bg-[#0D1117] border-gray-700"
                            : "bg-gray-50 border-gray-200"
                        }`}
                      />
                    </div>
                    <div className="sm:col-span-4">
                      <label
                        htmlFor="ville"
                        className={`block text-sm font-medium ${
                          isDarkMode ? "text-gray-400" : "text-600"
                        } `}
                      >
                        Ville <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        name="ville"
                        id="ville"
                        required
                        value={
                          showEditModal ? formEditData.ville : formNewData.ville
                        }
                        onChange={handleChange}
                        className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                          isDarkMode
                            ? "bg-[#0D1117] border-gray-700"
                            : "bg-gray-50 border-gray-200"
                        }`}
                      />
                    </div>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-4">
                  <div>
                    <label
                      htmlFor={`grade`}
                      className={`block text-sm font-medium ${
                        isDarkMode ? "text-gray-400" : "text-600"
                      } `}
                    >
                      Grade <span className="text-red-500">*</span>
                    </label>
                    <select
                      name="grade"
                      id="grade"
                      required
                      value={
                        showEditModal
                          ? formEditData.grade_id
                          : formNewData.grade_id
                      }
                      onChange={(e) =>
                        showEditModal
                          ? setFormEditData((prev) => ({
                              ...prev,
                              grade_id: e.target.value,
                            }))
                          : setFormNewData((prev) => ({
                              ...prev,
                              grade_id: e.target.value,
                            }))
                      }
                      className={`mt-1 block w-full h-12 border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                        isDarkMode
                          ? "bg-[#0D1117] border-gray-700"
                          : "bg-gray-50 border-gray-200"
                      }`}
                    >
                      <option value="">Sélectionner le grade</option>
                      {gradeDataArr.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.designation.toUpperCase()}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label
                      htmlFor={`domaine`}
                      className={`block text-sm font-medium ${
                        isDarkMode ? "text-gray-400" : "text-600"
                      } `}
                    >
                      Domaine <span className="text-red-500">*</span>
                    </label>
                    <select
                      name="domaine"
                      id="domaine"
                      required
                      value={
                        showEditModal
                          ? formEditData.domaine_id
                          : formNewData.domaine_id
                      }
                      onChange={(e) =>
                        showEditModal
                          ? setFormEditData((prev) => ({
                              ...prev,
                              domaine_id: e.target.value,
                            }))
                          : setFormNewData((prev) => ({
                              ...prev,
                              domaine_id: e.target.value,
                            }))
                      }
                      className={`mt-1 block w-full h-12 border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                        isDarkMode
                          ? "bg-[#0D1117] border-gray-700"
                          : "bg-gray-50 border-gray-200"
                      }`}
                    >
                      <option value="">Sélectionner le domaine</option>
                      {domainDataArr.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.designation.toUpperCase()}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div>
                    <label
                      htmlFor={`fonction`}
                      className={`block text-sm font-medium ${
                        isDarkMode ? "text-gray-400" : "text-600"
                      } `}
                    >
                      Fonction <span className="text-red-500">*</span>
                    </label>
                    <select
                      name="fonction"
                      id="fonction"
                      required
                      value={
                        showEditModal
                          ? formEditData.fonction_id
                          : formNewData.fonction_id
                      }
                      onChange={(e) =>
                        showEditModal
                          ? setFormEditData((prev) => ({
                              ...prev,
                              fonction_id: e.target.value,
                            }))
                          : setFormNewData((prev) => ({
                              ...prev,
                              fonction_id: e.target.value,
                            }))
                      }
                      className={`mt-1 block w-full h-12 border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                        isDarkMode
                          ? "bg-[#0D1117] border-gray-700"
                          : "bg-gray-50 border-gray-200"
                      }`}
                    >
                      <option value="">Sélectionner la fonction</option>
                      {functionDataArr.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.designation.toUpperCase()}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label
                      htmlFor="email"
                      className={`block text-sm font-medium ${
                        isDarkMode ? "text-gray-400" : "text-600"
                      } `}
                    >
                      Email <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="emal"
                      name="email"
                      id="email"
                      required
                      value={
                        showEditModal ? formEditData.email : formNewData.email
                      }
                      onChange={handleChange}
                      className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                        isDarkMode
                          ? "bg-[#0D1117] border-gray-700"
                          : "bg-gray-50 border-gray-200"
                      }`}
                    />
                  </div>
                  <div>
                    <label
                      htmlFor="telephone"
                      className={`block text-sm font-medium ${
                        isDarkMode ? "text-gray-400" : "text-600"
                      } `}
                    >
                      Téléphone
                    </label>
                    <input
                      type="tel"
                      name="telephone"
                      id="telephone"
                      required
                      value={
                        showEditModal
                          ? formEditData.telephone
                          : formNewData.telephone
                      }
                      onChange={handleChange}
                      className={`mt-1 block w-full border border-solid rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm  ${
                        isDarkMode
                          ? "bg-[#0D1117] border-gray-700"
                          : "bg-gray-50 border-gray-200"
                      }`}
                    />
                  </div>
                </div>
              </div>
            </>

            {/* Footer */}
            <div
              className={`px-6 py-2 border-t mt-2 ${
                isDarkMode ? "border-gray-700" : "border-gray-200"
              } flex justify-end space-x-3`}
            >
              <button
                disabled={
                  mutationUpdatePersonal.isPending ||
                  mutationCreatePersonal.isPending
                }
                onClick={() => {
                  showEditModal
                    ? setShowEditModal(false)
                    : setShowAddModal(false);
                  showEditModal
                    ? setFormEditData({
                        id: "",
                        nom: "",
                        postnom: "",
                        prenom: "",
                        genre: "",
                        ville: "",
                        commune: "",
                        quartier: "",
                        avenue: "",
                        telephone: "",
                        uid: "12345688",
                        fonction_id: "",
                        grade_id: "",
                        date_naissance: "",
                        lieu_naissance: "",
                        domaine_id: "",
                        email: "",
                      })
                    : setFormNewData({
                        nom: "",
                        postnom: "",
                        prenom: "",
                        genre: "",
                        ville: "",
                        commune: "",
                        quartier: "",
                        avenue: "",
                        telephone: "",
                        uid: "12345688",
                        fonction_id: "",
                        grade_id: "",
                        date_naissance: "",
                        lieu_naissance: "",
                        domaine_id: "",
                        email: "",
                      });
                }}
                className={`px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-gray-700 hover:bg-gray-600"
                    : "bg-gray-200 hover:bg-gray-300"
                } !rounded-button whitespace-nowrap ${
                  mutationUpdatePersonal.isPending ||
                  mutationCreatePersonal.isPending
                    ? "cursor-not-allowed"
                    : ""
                }`}
              >
                Annuler
              </button>

              <button
                disabled={
                  mutationUpdatePersonal.isPending ||
                  mutationCreatePersonal.isPending
                }
                onClick={() => {
                  showEditModal
                    ? handleUpdatePersonal()
                    : handleCreatePersonal();
                }}
                className={`px-4 py-2 rounded-md ${
                  isDarkMode
                    ? "bg-blue-600 hover:bg-blue-700"
                    : "bg-blue-500 hover:bg-blue-600"
                } text-white !rounded-button whitespace-nowrap  ${
                  mutationUpdatePersonal.isPending ||
                  mutationCreatePersonal.isPending
                    ? "cursor-not-allowed"
                    : ""
                }`}
              >
                {mutationUpdatePersonal.isPending ||
                mutationCreatePersonal.isPending ? (
                  <span className="flex items-center justify-center">
                    <i className="fas fa-spinner fa-spin mr-2"></i>
                    Chargement...
                  </span>
                ) : (
                  "Mettre à jour"
                )}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== NOTIFICATION ===== */}
      {notification && (
        <div
          className={`fixed bottom-4 right-4 px-6 py-3 z-50 rounded-lg text-white shadow-lg transition-all duration-500 ${
            notification.type === "success" ? "bg-green-500" : "bg-red-500"
          }`}
        >
          {notification.message}
        </div>
      )}
    </div>
  );
};

export default Personal;
